export default "__VITE_ASSET__Cll1tYcE__"